import { ReactNode } from "react";
import CaseBlockTitle from "../../common/case-block-title/case-block-title";
import { getAssetUrl } from "../../../api/api";
import "./cases-approach-block.sass";

type Props = {
  children: ReactNode;
  img: string;
  title: string;
  position?: string;
};

const CasesApproachBlock = ({
  children,
  img,
  title,
  position = "bottom",
}: Props) => {
  return (
    <div className={`cases-approach-block cases-approach-block--${position}`}>
      <div>
        <CaseBlockTitle>{title}</CaseBlockTitle>

        <div className="cases-approach-block__text">{children}</div>
      </div>

      <img
        src={getAssetUrl(img ?? "")}
        className={`cases-approach-block__img cases-approach-block__img--${position}`}
        alt={title}
      />
    </div>
  );
};

export default CasesApproachBlock;
